import dayjs from 'dayjs';
import 'dayjs/locale/th';
import _ from 'lodash';
import { useMediaQuery } from 'react-responsive';
export const convertObjPath = (_obj) => {
  if (!_obj || Object.keys(_obj).length < 1) return '';
  const entries = Object.entries(_obj);
  const itemData = encodeURI(`?${entries.join('&').split(',').join('=')}`);
  return itemData;
};

export const checkDataExisted = (dataSets, _topic) => {
  return !_.isEmpty(_.find(dataSets, { topic: _topic }));
};

export function FindValueObjectFromArray (arr, keyOfObj) {
  if (_.isEmpty(arr)) return null;
  return _.find(arr, { key: keyOfObj })?.value;
}

export const timestamp = () => {
  return dayjs(Date.now()).format('YYYY-MM-DD HH:MM:ss');
};

// useDateUpdate()
export function useDateUpdate (_date, _showTime) {
  if (!_date) return null;
  const _format = _showTime === true ? 'DD MMM YYYY |  HH:mm น.' : 'DD MMM YYYY';
  return dayjs(_date).locale('th').add(543, 'year').format(_format);
};

export function convertDatasets (data, topic, isValue) {
  const results = [];
  if (isValue === true) {
    for (let i = 0; i < data?.length; i++) {
      if (data[i].key.startsWith(topic)) {
        results.push(data[i].value);
      }
    }
  } else {
    for (let i = 0; i < data.length; i++) {
      if (data[i]?.topic?.startsWith(topic)) {
        results.push(data[i].dataSet);
      }
    }
  }
  return isValue ? results[0] : results;
}

export function convertDatasetsLists (data, topic) {
  const results = [];
  data.forEach(el => {
    const indexEl = topic.indexOf(el.key);
    if (indexEl !== -1) {
      return results.push(el.value);
    }
  }, []);

  return results;
}

export const useDesktop = () => useMediaQuery({ query: '(min-width: 1024px)' });
